import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, Eye, FileText, CalendarClock, Star, Sparkles, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";

export default function MagOverview() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/mag/overview").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="text-sm text-ink-muted p-8">Loading…</div>;
  const stats = [
    ["Published", data.published, BookOpen], ["Drafts", data.drafts, FileText],
    ["Scheduled", data.scheduled, CalendarClock], ["Total Views", data.total_views, Eye],
    ["Featured", data.featured, Star],
  ];
  return (
    <div className="space-y-6" data-testid="mag-overview">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="font-display text-2xl font-bold">{data.publication.name}</h1>
          <p className="text-sm text-ink-secondary mt-1">{data.publication.tagline}</p>
        </div>
        <div className="flex flex-wrap gap-2">
          <Link to="/dashboard/magazine/editor/new" data-testid="mag-create-article-btn"
            className="rounded-full bg-brand-amber text-black px-4 py-2 text-sm font-bold hover:opacity-90 transition">Create Article</Link>
          <Link to="/dashboard/magazine/ai-writer" data-testid="mag-ai-create-btn"
            className="inline-flex items-center gap-1.5 rounded-full border border-brand-cyan/60 text-brand-cyan px-4 py-2 text-sm font-bold hover:bg-brand-cyan/10 transition">
            <Sparkles className="h-4 w-4" /> AI Create Article</Link>
          <Link to="/dashboard/magazine/articles" data-testid="mag-manage-btn"
            className="rounded-full border border-line px-4 py-2 text-sm text-ink-secondary hover:text-ink-primary transition">Manage Articles</Link>
          <a href={`/mag/${data.publication.slug}`} target="_blank" rel="noreferrer" data-testid="mag-view-public-btn"
            className="inline-flex items-center gap-1.5 rounded-full border border-line px-4 py-2 text-sm text-ink-secondary hover:text-ink-primary transition">
            <ExternalLink className="h-4 w-4" /> View Magazine</a>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {stats.map(([label, val, Icon]) => (
          <div key={label} className="rounded-xl border border-line bg-bg-surface p-4" data-testid={`mag-stat-${label.toLowerCase().replace(" ", "-")}`}>
            <Icon className="h-4 w-4 text-brand-amber mb-2" />
            <div className="font-display text-2xl font-black">{val}</div>
            <div className="text-[10px] font-mono uppercase tracking-wider text-ink-muted">{label}</div>
          </div>
        ))}
      </div>
      {data.most_viewed && (
        <div className="rounded-xl border border-line bg-bg-surface p-4">
          <div className="text-[10px] font-mono uppercase tracking-wider text-ink-muted mb-1">Most Viewed Article</div>
          <div className="font-semibold">{data.most_viewed.title}</div>
          <div className="text-xs text-ink-muted font-mono mt-1">{data.most_viewed.views} views</div>
        </div>
      )}
    </div>
  );
}
